export default __webpack_public_path__ + "static/media/Icons_Cart_Cart_Empty_Bold.a1949f5e.svg";